import React from 'react'
import CategoryGrid from '../components/profession/CategoryGrid'

const ProfessionPage = () => {
  React.useEffect(() => {
    document.body.style.paddingTop = '50px'
    return () => {
      document.body.style.paddingTop = '0'
    }
  }, [])

  return (
    <div className="profession-page">
      <CategoryGrid />
    </div>
  )
}

export default ProfessionPage